"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reversePointTransform = exports["default"] = void 0;
var _get = _interopRequireDefault(require("lodash/get"));
var _find = _interopRequireDefault(require("lodash/find"));
var _flow = _interopRequireDefault(require("lodash/flow"));
var _Constants = require("redhotmagma-visualization/Constants");
var _visualizationAdapterCreator = require("redhotmagma-visualization/visualizationAdapterCreator");
var _AbstractVisualizationService = _interopRequireDefault(require("../../Framework/Services/AbstractVisualizationService"));
var _i18n = require("../../Framework/i18n");
var _ServiceLocator = require("../ServiceLocator");
var _configuration = require("../configuration");
var _Selectors = require("../Reducers/DesignArea/Selectors");
var _Selectors2 = require("../Reducers/Configurator/Selectors");
var _sendMessage = _interopRequireDefault(require("../../Utils/Function/sendMessage"));
var _Observable = _interopRequireDefault(require("../../Utils/Decorators/Observable"));
var _NoVisualization = require("../Screens/Configurator/Components/NoVisualization/NoVisualization");
var _Selectors3 = require("../Reducers/DesignView/Selectors");
var _Selectors4 = require("../Reducers/ConfigurationMode/Selectors");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var EventTypes = {
  ComponentChange: 'VisualizationService/ComponentChange',
  VisualizationUpdate: 'VisualizationService/VisualizationUpdate'
};
var VisualizationService = exports["default"] = /*#__PURE__*/function (_AbstractVisualizatio) {
  _inherits(VisualizationService, _AbstractVisualizatio);
  var _super = _createSuper(VisualizationService);
  function VisualizationService() {
    var _this;
    _classCallCheck(this, VisualizationService);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "observable", new _Observable["default"](_assertThisInitialized(_this)));
    _defineProperty(_assertThisInitialized(_this), "host", (0, _configuration.getConf)('network.host'));
    _defineProperty(_assertThisInitialized(_this), "adapterConfig", function () {
      var cfg = (0, _visualizationAdapterCreator.createAdapterConfig)({
        host: _this.host
      }, {
        "default": {
          Component: _NoVisualization.NoVisualization
        },
        '3dVariant': {
          basePath: "".concat(_this.host, "/content/3D")
        }
      });
      // mapping for backward compatibility
      return _objectSpread(_objectSpread({}, cfg), {}, {
        '3d': cfg['3dVariant'],
        '2d': cfg['2dVariant'],
        layer: cfg['2dLayer']
      });
    }());
    /**
     * Reference of the visualization instance
     * @type {null|object}
     * @private
     */
    _defineProperty(_assertThisInitialized(_this), "_component", null);
    /**
     * Function to release the camera movement restrictions
     * @type {null|function}
     * @private
     */
    _defineProperty(_assertThisInitialized(_this), "_removeRestrictedUserMovementZoomHandler", null);
    return _this;
  }
  _createClass(VisualizationService, [{
    key: "init",
    value: function init() {
      var _this2 = this;
      // skip initialization if the widget mode is active
      if (window.location.pathname.replace(/^\/([^/]*).*$/, '$1') === 'widget') {
        return;
      }
      _ServiceLocator.Services.store.observeStore(_Selectors2.getCurrentVisualizationSettings, function (target) {
        target !== 'fallback' && _this2.setComponent((0, _visualizationAdapterCreator.createVisualizationAdapter)(_this2.adapterConfig, target || 'default'));
      });
      _ServiceLocator.Services.store.observeStore((0, _flow["default"])(_Selectors2.getConfigurator, _Selectors2.getItem, function (_ref) {
        var parentItemIdentifier = _ref.parentItemIdentifier;
        return parentItemIdentifier;
      }), function (itemIdentifier) {
        (0, _sendMessage["default"])(_this2.getComponent(), 'updateItemPath', itemIdentifier);
      });
      _ServiceLocator.Services.store.observeStore((0, _flow["default"])(_Selectors2.getConfigurator, _Selectors2.getSelectedVariantIdentifier), function (variantIdentifier) {
        (0, _sendMessage["default"])(_this2.getComponent(), 'updateMaterialVariantPath', variantIdentifier);
      });
      _ServiceLocator.Services.store.observeStore(_Selectors.getSelectedDesignArea, this.designAreaChangeHandler.bind(this));
      _ServiceLocator.Services.store.observeStore(function (state) {
        return state.designView.selectedDesignView;
      }, function () {
        _this2.designViewChangeHandler((0, _Selectors3.getCurrentDesignView)(_ServiceLocator.Services.store.state));
      });
      _ServiceLocator.Services.store.observeStore(_Selectors4.getSelectedConfigurationMode, this.configurationModeChangeHandler.bind(this));
    }
  }, {
    key: "configurationModeChangeHandler",
    value: function configurationModeChangeHandler(mode) {
      _ServiceLocator.Services.designData.clearDesignAreaSelection();
      this.initDesignAreaInteraction(mode);
    }
  }, {
    key: "updateDesignAreaList",
    value: function () {
      var _updateDesignAreaList = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(designAreaList) {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return (0, _sendMessage["default"])(this.getComponent(), 'updateDesignAreaList', designAreaList);
            case 2:
              _context.next = 4;
              return this.designViewChangeHandler((0, _Selectors3.getCurrentDesignView)(_ServiceLocator.Services.store.state));
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function updateDesignAreaList(_x) {
        return _updateDesignAreaList.apply(this, arguments);
      }
      return updateDesignAreaList;
    }()
  }, {
    key: "isReadyToRender",
    value: function isReadyToRender() {
      return (0, _sendMessage["default"])(this.getComponent(), 'isInitialized');
    }
  }, {
    key: "isReadyToRenderCustomDesign",
    value: function isReadyToRenderCustomDesign() {
      return (0, _sendMessage["default"])(this.getComponent(), 'isCustomizableMaterialAvailable');
    }
  }, {
    key: "render",
    value: function render() {
      return (0, _sendMessage["default"])(this.getComponent(), 'render');
    }
  }, {
    key: "update2DMaxZoom",
    value: function update2DMaxZoom(maxZoom) {
      return (0, _sendMessage["default"])(this.getComponent(), 'updateMaxZoomSetting', maxZoom);
    }
  }, {
    key: "updateVariant",
    value: function updateVariant(variantIdentifier) {
      return (0, _sendMessage["default"])(this.getComponent(), 'updateMaterialVariantPath', variantIdentifier);
    }
  }, {
    key: "setActiveDesignArea",
    value: function setActiveDesignArea(designArea) {
      return (0, _sendMessage["default"])(this.getComponent(), 'setActiveDesignArea', designArea);
    }
  }, {
    key: "getActiveDesignArea",
    value: function getActiveDesignArea() {
      return (0, _sendMessage["default"])(this.getComponent(), 'getActiveDesignArea');
    }
  }, {
    key: "designAreaChangeHandler",
    value: function () {
      var _designAreaChangeHandler = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var designArea, visualization, state, modeCheck, viewName;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              designArea = (0, _Selectors.getSelectedDesignArea)(_ServiceLocator.Services.store.state);
              visualization = this.getComponent();
              this.setActiveDesignArea(designArea);
              state = _ServiceLocator.Services.store.state;
              modeCheck = (0, _Selectors2.visualizationModeCheck)(state);
              if (!modeCheck.is3D()) {
                _context2.next = 11;
                break;
              }
              viewName = (0, _Selectors.getSelectedViewName)(designArea);
              _context2.next = 9;
              return (0, _sendMessage["default"])(visualization, 'jumpToView', viewName);
            case 9:
              _context2.next = 14;
              break;
            case 11:
              if (!(modeCheck.is2D() && designArea.identifier)) {
                _context2.next = 14;
                break;
              }
              _context2.next = 14;
              return (0, _sendMessage["default"])(visualization, 'jumpToArea', designArea.identifier);
            case 14:
              // make sure every state update and change event is triggered before updating the visualization
              // root case: get the canvas data with cleared selection
              setTimeout(function () {
                return _ServiceLocator.Services.designData.updateVisualization();
              });
            case 15:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function designAreaChangeHandler() {
        return _designAreaChangeHandler.apply(this, arguments);
      }
      return designAreaChangeHandler;
    }()
  }, {
    key: "getViewChangedPromise",
    value: function getViewChangedPromise() {
      return this._viewChangedPromise;
    }
  }, {
    key: "designViewChangeHandler",
    value: function () {
      var _designViewChangeHandler = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(designView) {
        var visualization;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (designView) {
                _context3.next = 2;
                break;
              }
              return _context3.abrupt("return");
            case 2:
              visualization = this.getComponent();
              this._viewChangedPromise = (0, _sendMessage["default"])(visualization, 'setView', designView);
              _context3.next = 6;
              return this._viewChangedPromise;
            case 6:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function designViewChangeHandler(_x2) {
        return _designViewChangeHandler.apply(this, arguments);
      }
      return designViewChangeHandler;
    }()
  }, {
    key: "setComponent",
    value: function setComponent(component) {
      var _this3 = this;
      if (!component) {
        throw new Error('Component must be provided!');
      }
      (0, _sendMessage["default"])(this._component, 'dispose');
      this._component = component;
      if ((0, _Selectors2.isDesignerProductPreviewMode)()) {
        (0, _sendMessage["default"])(component, 'init');
        (0, _sendMessage["default"])(component, 'setSize', {
          width: 10,
          height: 10
        });
      }

      // add listener to the three adapter to catch intersections with the pointer
      component.observable.on(_Constants.EventTypes.Intersection, function (evt) {
        if (_ServiceLocator.Services.designData.handleCloseIfNeeded()) {
          // if it performed any actions, just return
          return;
        }

        // get the texture data from the intersection
        var getTextureHit = evt.data.getTextureHit;
        // so we can test if a design area was clicked
        var area = _this3.testTextureIntersection(getTextureHit());
        if (area) {
          // the design area change already invokes the jumpToView function
          _ServiceLocator.Services.designData.selectDesignArea(area.identifier);
        } else {
          // clear the selection if the click did not hit the area
          _ServiceLocator.Services.designData.clearDesignAreaSelection();
        }
      });

      // add click-away listener too, so the design area selection can be cleared
      component.observable.on(_Constants.EventTypes.ClickAway, function () {
        _ServiceLocator.Services.designData.handleCloseIfNeeded();
      });
      this.addAreaHoverHandler(component);

      // the design areas should be redrawn when the material is updated
      component.observable.on(_Constants.EventTypes.MaterialUpdated, /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(updateEventObject) {
          return _regeneratorRuntime().wrap(function _callee4$(_context4) {
            while (1) switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return _ServiceLocator.Services.designData.updateVisualization(updateEventObject);
              case 2:
                _this3.observable.dispatch(EventTypes.VisualizationUpdate, updateEventObject);
              case 3:
              case "end":
                return _context4.stop();
            }
          }, _callee4);
        }));
        return function (_x3) {
          return _ref2.apply(this, arguments);
        };
      }());
      component.observable.on(_Constants.EventTypes.LoadStart, function () {
        _ServiceLocator.Services.ui.show('loadVisualization');
      });
      component.observable.on(_Constants.EventTypes.LoadFinished, function () {
        _ServiceLocator.Services.ui.hide('loadVisualization');
      });
      component.observable.on(_Constants.EventTypes.LoadError, function () {
        _ServiceLocator.Services.ui.hide('loadVisualization');
      });
      component.observable.on(_Constants.EventTypes.Error, function () {
        _ServiceLocator.Services.ui.reportError((0, _i18n.t)('visualization.errors.visualizationNotPossible'));
      });
      component.observable.on(_Constants.EventTypes.EmptySceneError, function () {
        _ServiceLocator.Services.ui.reportError((0, _i18n.t)('visualization.errors.visualizationNotPossible'));
      });

      // in dev mode expose the three object to the window
      if (!(0, _configuration.isProduction)()) {
        window.visualization = component;
      }
      if (component.getScreenshotsSync) {
        this.registerScreenshotsGetter(component.getScreenshotsSync.bind(component));
      }
      if (component.setView) {
        component.setView(_ServiceLocator.Services.store.state.designView.selectedDesignView);
      }
      if (component.update) {
        this.registerUpdateFunction(component.update.bind(component));
        this.update((0, _Selectors2.getConfiguration)(_ServiceLocator.Services.configurator.state));
      }
      if (component.getDrawingContext) {
        this.registerTextureUpdateFunction(this.drawDesignAreasOnTexture.bind(this));
      }
      if (component.toggleCameraLock) {
        this.registerCameraLockFunction(component.toggleCameraLock.bind(component));
      }
      if (component.toggleHitTest) {
        this.registerToggleHitTestFunction(component.toggleHitTest.bind(component));
      }
      var isAdminMode = (0, _configuration.getConf)('adminMode');
      (0, _sendMessage["default"])(component, 'clearViewIfEmpty', !!isAdminMode);
      var state = _ServiceLocator.Services.store.state;
      var visualizationOverlayMode = (0, _Selectors2.visualizationModeCheck)(state).is2DOverlay();
      (0, _sendMessage["default"])(component, 'setOverlayMode', !!visualizationOverlayMode);
      var visualizationOptions = (0, _configuration.getConf)('visualization.options');
      (0, _sendMessage["default"])(component, 'setOptions', visualizationOptions);
      var visualizationOptions3D = (0, _configuration.getConf)('visualization.options3D');
      (0, _sendMessage["default"])(component, 'setOptions3D', visualizationOptions3D);
      this.observable.dispatch(EventTypes.ComponentChange, {
        component: component
      });
      return this;
    }
  }, {
    key: "addAreaHoverHandler",
    value: function addAreaHoverHandler(component) {
      var _this4 = this;
      var isAreaHovered = false;
      var toggleAreaHovered = function toggleAreaHovered(isHovered) {
        if (isAreaHovered !== isHovered && component !== null && component !== void 0 && component.getContainer) {
          isAreaHovered = isHovered;
          component.getContainer().style.cursor = isAreaHovered ? 'pointer' : '';
        }
      };
      component.observable.on(_Constants.EventTypes.HoverIn, function (evt) {
        // get the texture data from the intersection
        var getTextureHit = evt.data.getTextureHit;
        // so we can test if a design area was clicked
        var area = _this4.testTextureIntersection(getTextureHit());
        toggleAreaHovered(!!area);
      });
      component.observable.on(_Constants.EventTypes.HoverOut, function () {
        toggleAreaHovered(false);
      });
    }
  }, {
    key: "disposeComponent",
    value: function disposeComponent() {
      (0, _sendMessage["default"])(this._component, 'dispose');
      this._component = null;
      this.observable.dispatch(EventTypes.ComponentChange, {
        component: null
      });
    }
  }, {
    key: "getComponent",
    value: function getComponent() {
      return this._component;
    }
  }, {
    key: "registerComponentChangeListener",
    value: function registerComponentChangeListener(fn) {
      return this.observable.on(EventTypes.ComponentChange, fn);
    }
  }, {
    key: "registerVisualizationUpdateListener",
    value: function registerVisualizationUpdateListener(fn) {
      this.observable.on(EventTypes.VisualizationUpdate, fn);
    }
  }, {
    key: "update",
    value: function update(configuration) {
      if (this._onUpdateFn) {
        this._onUpdateFn(configuration);
      } else {
        // save it for later if there is no update function registered yet
        this._configuration = configuration;
      }
      return this;
    }
  }, {
    key: "registerUpdateFunction",
    value: function registerUpdateFunction(onUpdateFn) {
      this._onUpdateFn = onUpdateFn;
      // call the update method if there was already a call for it
      if (this._configuration) {
        this.update(this._configuration);
        delete this._configuration;
      }
      return this;
    }
  }, {
    key: "registerCameraLockFunction",
    value: function registerCameraLockFunction(cameraLockFunction) {
      this._cameraLockFunction = cameraLockFunction;
      return this;
    }
  }, {
    key: "registerToggleHitTestFunction",
    value: function registerToggleHitTestFunction(toggleHitTest) {
      this._toggleHitTest = toggleHitTest;
      return this;
    }

    /**
     * Register the getScreenshots function in the service so it can be proxied to others via this instance
     * @param {function} getScreenshotsFn
     */
  }, {
    key: "registerScreenshotsGetter",
    value: function registerScreenshotsGetter(getScreenshotsFn) {
      this._getScreenshotsFn = getScreenshotsFn;
      return this;
    }

    /**
     * Calls the registered getScreenshot function or returns a resolved Promise
     * @param {object} options The options object forwarded the getScreenshot function
     * @returns {*}
     */
  }, {
    key: "getScreenshots",
    value: function () {
      var _getScreenshots = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var options,
          screenshots,
          _args5 = arguments;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              options = _args5.length > 0 && _args5[0] !== undefined ? _args5[0] : {};
              screenshots = null;
              if (!this._getScreenshotsFn) {
                _context5.next = 5;
                break;
              }
              _context5.next = 5;
              return this._getScreenshotsFn(function (result) {
                screenshots = result;
              }, options);
            case 5:
              return _context5.abrupt("return", screenshots);
            case 6:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function getScreenshots() {
        return _getScreenshots.apply(this, arguments);
      }
      return getScreenshots;
    }()
  }, {
    key: "abortScreenshotting",
    value: function abortScreenshotting() {
      return (0, _sendMessage["default"])(this.getComponent(), 'abortScreenshotting');
    }

    /**
     * Register a callback for the updateTexture method
     * If there was already a texture update call it triggers the callback immediately with the latest argument.
     * @param {function} onUpdateFn
     * @returns {VisualizationService}
     */
  }, {
    key: "registerTextureUpdateFunction",
    value: function registerTextureUpdateFunction(onUpdateFn) {
      this._onTextureUpdateFn = onUpdateFn;
      // call the update method if there was already a call for it
      if (this._textureUpdateRequest) {
        this.updateTexture(this._textureUpdateRequest);
        delete this._textureUpdateRequest;
      }
      return this;
    }

    /**
     * Calls the previously registered texture update function, if there is any
     * Otherwise it stores the argument internally, so it can be used in the registerTextureUpdateFunction method.
     * @param {*} textureUpdateInfo
     */
  }, {
    key: "updateTexture",
    value: function () {
      var _updateTexture = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var textureUpdateInfo,
          _args6 = arguments;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              textureUpdateInfo = _args6.length > 0 && _args6[0] !== undefined ? _args6[0] : {};
              if (!this._onTextureUpdateFn) {
                _context6.next = 6;
                break;
              }
              _context6.next = 4;
              return this._onTextureUpdateFn(textureUpdateInfo);
            case 4:
              _context6.next = 7;
              break;
            case 6:
              // save it for later if there is no update function registered yet
              this._textureUpdateRequest = textureUpdateInfo;
            case 7:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function updateTexture() {
        return _updateTexture.apply(this, arguments);
      }
      return updateTexture;
    }()
  }, {
    key: "drawDesignAreasOnTexture",
    value: function () {
      var _drawDesignAreasOnTexture = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(_ref3) {
        var drawingFunction, updateEventObject, getDrawingContext;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              drawingFunction = _ref3.drawingFunction, updateEventObject = _ref3.updateEventObject;
              _context7.prev = 1;
              getDrawingContext = this._component.getDrawingContext.bind(this._component);
              _context7.t0 = drawingFunction;
              if (!_context7.t0) {
                _context7.next = 7;
                break;
              }
              _context7.next = 7;
              return drawingFunction(getDrawingContext, updateEventObject);
            case 7:
              _context7.next = 12;
              break;
            case 9:
              _context7.prev = 9;
              _context7.t1 = _context7["catch"](1);
              // eslint-disable-next-line no-console
              console.log('Skipping texture update: drawing context is not available.');
            case 12:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this, [[1, 9]]);
      }));
      function drawDesignAreasOnTexture(_x4) {
        return _drawDesignAreasOnTexture.apply(this, arguments);
      }
      return drawDesignAreasOnTexture;
    }()
  }, {
    key: "disableUserMovement",
    value: function disableUserMovement() {
      if (this._cameraLockFunction) {
        this._cameraLockFunction(true);
      }
    }
  }, {
    key: "enableUserMovement",
    value: function enableUserMovement() {
      if (this._cameraLockFunction) {
        this._cameraLockFunction(false);
      }
    }
  }, {
    key: "restrictUserMovement",
    value: function restrictUserMovement() {
      var _this5 = this;
      var component = this.getComponent();
      if (!component) {
        return;
      }
      var zoomHandler = function zoomHandler(_ref4) {
        var direction = _ref4.data.direction;
        if (direction === 'out') {
          _this5._removeRestrictedUserMovementZoomHandler && _this5._removeRestrictedUserMovementZoomHandler();
          _ServiceLocator.Services.designData.clearDesignAreaSelection();
        }
      };
      component.observable.on(_Constants.EventTypes.Zoomed, zoomHandler);
      this._removeRestrictedUserMovementZoomHandler = function () {
        component.observable.off(_Constants.EventTypes.Zoomed, zoomHandler);
        _this5._removeRestrictedUserMovementZoomHandler = null;
      };
      (0, _sendMessage["default"])(component, 'restrictUserMovement');
    }
  }, {
    key: "freeUserMovement",
    value: function freeUserMovement() {
      this._removeRestrictedUserMovementZoomHandler && this._removeRestrictedUserMovementZoomHandler();
      (0, _sendMessage["default"])(this.getComponent(), 'freeUserMovement');
    }
  }, {
    key: "toggleHitTest",
    value: function toggleHitTest(enabled) {
      if (this._toggleHitTest) {
        this._toggleHitTest(enabled);
      }
    }
  }, {
    key: "initDesignAreaInteraction",
    value: function initDesignAreaInteraction() {
      var configurationMode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _Selectors4.getSelectedConfigurationMode)(_ServiceLocator.Services.store.state);
      this.enableDesignAreaInteraction((0, _Selectors4.isDesignerMode)(configurationMode));
    }
  }, {
    key: "enableDesignAreaInteraction",
    value: function enableDesignAreaInteraction(enable) {
      _ServiceLocator.Services.designData.toggleHighlight(enable);
      _ServiceLocator.Services.visualization.toggleHitTest(enable);
    }

    /**
     * Tests if the point from the given texture intersection point is inside of a design area
     * @param textureIntersectionData
     * @see Three.getIntersection
     * @see Three.getTextureHit
     * @returns {*} The design area that contains the given point if any, false otherwise
     */
  }, {
    key: "testTextureIntersection",
    value: function testTextureIntersection(textureIntersectionData) {
      if (textureIntersectionData) {
        var x = textureIntersectionData.x,
          y = textureIntersectionData.y,
          designAreaIdentifier = textureIntersectionData.designAreaIdentifier,
          currentView = textureIntersectionData.currentView;
        var designAreas = _ServiceLocator.Services.designData.getDesignAreas();

        // If the designAreaIdentifier is provided just try to find it in the list.
        // This can be used in any visualization adapter that maps different materials (with own texture) to
        // each design areas. Currently it is being used in the Three2D adapter.
        if (designAreaIdentifier !== undefined) {
          var designAreaSource = (0, _get["default"])(currentView, 'designAreas') || designAreas;
          var foundArea = (0, _find["default"])(designAreaSource, {
            identifier: designAreaIdentifier
          }) || false;
          if (foundArea && foundArea.position && Object.keys(foundArea.position).length > 0) {
            designAreas = [foundArea];
          } else {
            return foundArea;
          }
        }
        // Otherwise it can be treated as a single texture that contains all the areas combined into one.
        // In this case the visualization adapter cannot give a hint about the clicked area,
        // therefore we have to find it by checking the intersection point falls into any of the area ranges.
        var _iterator = _createForOfIteratorHelper(designAreas),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var area = _step.value;
            var _area$position = area.position,
              aWidth = _area$position.width,
              aHeight = _area$position.height;
            var _reversePointTransfor = reversePointTransform(area.position, x, y),
              tX = _reversePointTransfor.x,
              tY = _reversePointTransfor.y;
            var left = -aWidth / 2;
            var right = left + +aWidth;
            var top = -aHeight / 2;
            var bottom = top + +aHeight;
            if (tX >= left && tX <= right && tY >= top && tY <= bottom) {
              return area;
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
      return false;
    }
  }]);
  return VisualizationService;
}(_AbstractVisualizationService["default"]);
/**
 * This function was copied from the redhotmagma-configurator-administrationgui project
 * original source: src/Screens/Designer/SubScreens/Visualization/Components/FunDraw.js
 * It transforms the given (x, y) coordinates to a locale coordinate of the given object.
 * FIXME: replace if the function is available as an export of a standalone module
 * @param object
 * @param x
 * @param y
 * @returns {{x: number, y: number}}
 */
var reversePointTransform = exports.reversePointTransform = function reversePointTransform(object, x, y) {
  var _x$y$angle$object = _objectSpread({
      x: 0,
      y: 0,
      angle: 0
    }, object),
    cx = _x$y$angle$object.x,
    cy = _x$y$angle$object.y,
    angle = _x$y$angle$object.angle;
  var ox = x - cx;
  var oy = y - cy;
  var cosAi = Math.cos(-angle);
  var sinAi = Math.sin(-angle);
  return {
    x: ox * cosAi - oy * sinAi,
    y: oy * cosAi + ox * sinAi
  };
};